export default "__VITE_ASSET__277efa9e__"